import { WorkspaceFilterKey, WorkspaceFilterModel } from '../domain';
import { useFilter } from '../../filter';

export const useWorkspaceFilter = () => {
  return useFilter(
    WorkspaceFilterKey,
    'workspaceFilter',
    (filter: any) => new WorkspaceFilterModel(filter)
  );
};
